import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import React, { useEffect, useState } from 'react'
import { selectRequirementTitle, usePackageStore } from 'stores/packageStore'
import { useFlagActions } from '../hooks/useFlagActions'
import RequirementFlagGroup from './RequirementFlagGroup'
import flagPlusIcon from '/app/assets/images/icons/flag-plus.svg'
import { ControlArea } from '../FlagControlArea'

const CLOSED_STATE = { open: false, requirementId: null, flags: [] }

export default function ApplicantLockConfirmationModal({ packageId }) {
  const [state, setState] = useState(CLOSED_STATE)
  const { markFixed } = useFlagActions(packageId)
  const requirementName = usePackageStore(selectRequirementTitle(state.requirementId))

  useEffect(() => {
    const handler = (e) => {
      const { requirementId, flags } = e.detail
      setState({ open: true, requirementId, flags })
    }
    document.addEventListener('package:applicant-lock-confirm', handler)
    return () => document.removeEventListener('package:applicant-lock-confirm', handler)
  }, [])

  useEffect(() => {
    document.body.classList.toggle('overlay-activated', state.open)
    return () => {
      document.body.classList.remove('overlay-activated')
    }
  }, [state.open])

  const handleCancel = () => setState(CLOSED_STATE)

  const handleConfirm = async () => {
    const { flags, requirementId } = state
    await Promise.all(flags.map((f) => markFixed(f.id)))

    setState(CLOSED_STATE)
    document.dispatchEvent(new CustomEvent('package:applicant-lock-confirm-proceed', { detail: { requirementId } }))
  }

  return (
    <Portal>
      <div className={clsx('lock-confirmation-overlay dome-full-width dome-full-height', state.open && 'show')}>
        <div className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center">
          <div className="lock-confirmation-modal dome-d-flex dome-flex-column dome-gap18">
            <div className="dome-d-flex dome-flex-column dome-gap12">
              <div>
                <img src={flagPlusIcon} />
              </div>
              <div className="dome-h2 dome-color-dark-green">complete requirement?</div>
            </div>
            <div className="dome-p1 dome-color-dark-grey">
              Completing this section will{' '}
              <span className="dome-color-darkest-grey dome-p1 dome-text-w500">
                also clear the {state.flags.length > 1 ? `${state.flags.length} flags` : 'flag'}
              </span>{' '}
              that have been marked:
            </div>
            <div className='lock-all-requirement-list'>
              <RequirementFlagGroup requirement={{ requirementName, flags: state.flags }} />
            </div>
            <div className="modal-footnote">
              <div className="dome-color-dark-grey dome-text-style-italic">
                View flag history by clicking the requirement or file, then &ldquo;completed.&rdquo;
              </div>
            </div>
            <ControlArea.RedactReminder />
            <div className="modal-actions">
              <button className="dome-btn dome-btn-link dome-btn-link-back" onClick={handleCancel}>
                back
              </button>
              <button className="dome-btn dome-btn-base dome-btn-dark-green" onClick={handleConfirm}>
                yes, complete
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}
